export default __webpack_public_path__ + "static/media/dental.f36db0d2.svg";